import NutrientByIngredientModal from './NutrientByIngredientModal';
export default NutrientByIngredientModal;